import setIsSearching from './setIsSearching';
import datapoints from '../datapoints';
import { findPeople } from 'owa-recipient-common/lib/services/findPeople';
import AtMentionsViewState from '../store/schema/AtMentionsViewState';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import processFindPeopleResult from 'owa-recipient-common/lib/actions/processFindPeopleResult';
import setSuggestedContacts from './setSuggestedContacts';
import { action } from 'satcheljs/lib/legacy';

const MAX_ENTRIES = 5;

export default action('findReadWriteRecipient', datapoints.MentionsFindPeople)(
    async function findReadWriteRecipient(
        viewState: AtMentionsViewState,
        queryString: string,
        searchDirectory: boolean
    ): Promise<void> {
        viewState.queryString = queryString;
        if (!queryString) {
            const datapoint = returnTopExecutingActionDatapoint();
            setSuggestedContacts(viewState);
            datapoint.addCustomData({ zeroState: true.toString() });
            return Promise.resolve();
        } else {
            setIsSearching(viewState, true /* isSearching */);
            return findPeople(queryString, searchDirectory).then(findPeopleResult => {
                const datapoint = returnTopExecutingActionDatapoint();
                setIsSearching(viewState, false /* isSearching */);
                const sameQueryString = viewState.queryString.trim() == queryString;
                if (sameQueryString) {
                    viewState.selectedRecipientIndex = 0;
                    viewState.hasSearchedDirectory = searchDirectory;
                    processFindPeopleResult(
                        viewState.recipientsShown,
                        findPeopleResult,
                        false /*appendResults*/,
                        MAX_ENTRIES
                    );
                }
                datapoint.addCustomData({
                    zeroState: false.toString(),
                    sameQueryString: sameQueryString.toString(),
                    searchDirectory: searchDirectory.toString(),
                });
            });
        }
    }
);
